import React, { FC } from 'react';
import { Row, Col, CardDeck, Card, CardBody, CardText, CardFooter } from 'reactstrap';
import classnames from 'classnames';
import TruncateMarkup from 'react-truncate-markup';
import parse from 'html-react-parser';
import { useTranslations } from 'next-intl';

// Currently scoped styles not used  - comment out until required.
//import styles from './SingleItemLarge.module.scss';

//import components
import GridImages from '@/components/GridImages/GridImages';
import { useResourceContext } from '@/context/resourceContext';

// Libraries
import LeadDropDownloadBtn from '@/libs/LeadDrop/LeadDrop';
import { fulfillmentPageCompsProps } from '@/libs/interfaceProps/fulfillmentPageCompsProps';
import { sanitizeTitle } from '@/libs/sanitizeTitle/sanitizeTitle';
import useResFallbackImages from '@/libs/resFallbackImages/resFallbackImages';
import { sitenameImageIndexHandler } from '@/libs/sitenameImageIndexHandler/sitenameImageIndexHandler';
import { pushGTMClickTags } from '@/libs/pushGTMTags/pushGTMTags';
const SingleItemLarge: FC<fulfillmentPageCompsProps> = ({
  params,
  queryParams
}) => {
  const t = useTranslations('Fulfillment');
  const {
    relatedAssets
  } = useResourceContext();
  const fallbackImages = useResFallbackImages();
  const sitenameImageIndex: Record<string, number> = {};
  const data = relatedAssets?.[0];
  const leadDropDownloadHandler = LeadDropDownloadBtn(params, queryParams);
  if (data) {
    const {
      bestTitle,
      shortDescription,
      docType,
      orgName,
      resId,
      hasVendorQuestions,
      primarySiteName
    } = data;
    return <>
    <div className={'section-dividers'}>
     <hr />
    </div>

    <Row className={'gx-'}>
     <h2 className={'section-heading'} data-bdd={'section-heading_download-next'}>
      {t('DownloadNext')}
     </h2>
    </Row>

    <Row className={'singleitemlarge-row'} data-bdd="singleitem-row">
     <CardDeck>
      <Card className={'singleitem-card'}>
       <Col sm="12" md="4" lg="4">
        <div className={classnames('grid-image-wrap', 'faux-letterbox')}>
         <a className="asset-link" onClick={e => {
                  leadDropDownloadHandler(e, resId, hasVendorQuestions);
                  pushGTMClickTags({
                    click_element: 'Anchor',
                    click_closest_class: 'grid-image-wrap',
                    click_section_ID: 'NONE',
                    link_classes: 'asset-link',
                    link_id: 'NONE',
                    link_text: 'NONE',
                    link_url: `hub/asset/${resId}`,
                    click_category: 'NONE',
                    click_destination: 'Asset page',
                    click_closest_href: 'NONE'
                  });
                }}>
          <GridImages GridType={'singlegridlarge'} resId={resId} primarySiteName={primarySiteName} fallbackimage={sitenameImageIndexHandler(sitenameImageIndex, fallbackImages, primarySiteName)} />
         </a>
        </div>
       </Col>

       <Col sm="12" md="8" lg="8">
        <CardBody className={'card-body'}>
         <CardText className={'asset-type-string'}>{docType}</CardText>

         {typeof bestTitle === 'string' && bestTitle.length > 0 && <TruncateMarkup lines={2} tokenize={'words'}>
           <a className="asset-link" onClick={e => {
                    leadDropDownloadHandler(e, resId, hasVendorQuestions);
                    pushGTMClickTags({
                      click_element: 'Anchor',
                      click_closest_class: 'NONE',
                      click_section_ID: 'NONE',
                      link_classes: 'asset-link',
                      link_id: 'NONE',
                      link_text: bestTitle,
                      link_url: `hub/asset/${resId}`,
                      click_category: 'NONE',
                      click_destination: 'Asset page',
                      click_closest_href: 'NONE'
                    });
                  }}>
            <h3 className={'asset-title'}>{parse(sanitizeTitle(bestTitle))}</h3>
           </a>
          </TruncateMarkup>}

         {/*  Trucate module expects a strict string passed, only display if var is string and has length */}
         {typeof shortDescription === 'string' && shortDescription.length > 0 && <TruncateMarkup lines={3} tokenize={'words'}>
            <p className={'asset-descrip'}>
             {parse(sanitizeTitle(shortDescription))}
            </p>
           </TruncateMarkup>}

         <CardFooter>
          <a className={'tt-button-med'} onClick={e => {
                    leadDropDownloadHandler(e, resId, hasVendorQuestions);
                  }}>
           {t('Download')}
          </a>
          <span className={'download-button-text'}>
           {' '}
           {t('By')} <span className={'client-name'}>{orgName}</span>
          </span>
         </CardFooter>
        </CardBody>
       </Col>
      </Card>
     </CardDeck>
    </Row>
   </>;
  }
};
export default SingleItemLarge;